import { useAuth0 } from 'shim/auth0-react'
import useSWR from 'swr'

import { GET_PROJECTS } from '../queries'
import type { Project } from './useProject'
import { consoleFetcher } from 'common/fetchers/graphql'

export default function useProjects(accountId?: string) {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0()

  const { data, error, mutate } = useSWR(
    (isAuthenticated || process.env.NEXT_PUBLIC_BYPASS_AUTH_STATE) && accountId
      ? [GET_PROJECTS, { accountId: accountId }, { tokenFn: getAccessTokenSilently }]
      : false,
    consoleFetcher,
    { shouldRetryOnError: false, refreshInterval: 5000 }
  )

  const keiProjects = data?.account?.applications

  return {
    projects: data ? (keiProjects as Project[]) : null,
    loading: typeof keiProjects === 'undefined' && !error,
    error: error || null,
    mutate,
  }
}
